import {
  GenerateRandomId,
  chromeExtension,
  extensionName,
  reqEventName,
  respEventName
} from '../const/certenrollment.js'


import {standardBrowser, BrowserInfo} from '../const/browser.js'

const isChrome = BrowserInfo.name === standardBrowser.Chrome
// 统一错误处理规则
// 返回为null， Extension has been remove

const SendMsgforChrome = (request) => {
  // console.info(request.funcInfo.function + '--------' + request.funcInfo.params)
  return new Promise((resolve, reject)=> {
    chrome.runtime.sendMessage(chromeExtension, request, (response)=> {
      // console.log('中心错误------------' , response)
      if (response) {
				if(response.errorcode == 0){ 
          resolve(response)                                    
				} else { 
          console.log(response)
          if(response.errorcode == 1) {
            reject(response)
          }else{
            return getLastErrorDesc().then((res) => {
              reject(res)
            })
          }
				}
			} else {
			    reject({errorcode:1, result: chrome.runtime.lastError.message})
			}
    })
  })
}


const SendMsgByEvent = (request)=> {
  let event = new CustomEvent(reqEventName, { detail: request })
  document.dispatchEvent(event)

  return new Promise((resolve, reject)=> {
    let responseEventName = respEventName
    if(request.funcInfo != undefined && request.funcInfo.randomId != undefined){
      responseEventName += ("." + request.funcInfo.randomId)
    }
    document.addEventListener(responseEventName, CallBack = (e)=>{
      document.removeEventListener(e.type, CallBack)
      var eJson = JSON.parse(e.detail)
        if (eJson && eJson.errorcode == 0) {
          resolve(eJson)
        } else {
          reject(eJson)
        }
    }, false)
  })
}

export const SendMsg = (requestJSON)=> {
  if (isChrome) {
    return SendMsgforChrome(requestJSON)
  } else {
    return SendMsgByEvent(requestJSON)
  }
}

export const getLastErrorDesc = ()=> {
  let request = {
    action: 'invoke',
    funcInfo: {
      function: 'GetLastErrorDesc',
      params: null,
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}


// WEBPACK FOOTER //
// ./apps/cfca/cofco/sendMsg/index.js